<template>
  <el-dialog
    title="Сдача отчета(-ов)"
    :visible="visible"
    width="40%"
    @close="beforeClose"
  >
    <el-form
      ref="reportForm"
      :model="report"
      :rules="rules"
      @submit.native.prevent
    >
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item prop="total_report_title_1">
            <p>Заголовок 1</p>
            <el-input
              v-model="report.total_report_title_1"
              placeholder="Введите текст"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="total_report_title_2">
            <p>Заголовок 2</p>
            <el-input
              v-model="report.total_report_title_2"
              placeholder="Введите текст"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="total_report_title_3">
            <p>Заголовок 3</p>
            <el-input
              v-model="report.total_report_title_3"
              placeholder="Введите текст"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="total_report_table_title">
            <p>Заголовок таблицы</p>
            <el-input
              v-model="report.total_report_table_title"
              placeholder="Введите текст"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="reportSubmit"> Готово </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'

const Doc = RepositoryFactory.get('doc')

export default {
  name: 'ReportSubmit',
  props: {
    ids: {
      type: Array,
      default: () => [],
    },
    fetchBids: {
      type: Function,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      report: {
        total_report_title_1: '',
        total_report_title_2: '',
        total_report_title_3: '',
        total_report_table_title: '',
      },
      rules: {
        total_report_title_1: {
          required: true,
          message: 'Заполните поле',
          trigger: 'blur',
        },
        total_report_title_2: {
          required: true,
          message: 'Заполните поле',
          trigger: 'blur',
        },
        total_report_title_3: {
          required: true,
          message: 'Заполните поле',
          trigger: 'blur',
        },
        total_report_table_title: {
          required: true,
          message: 'Заполните поле',
          trigger: 'blur',
        },
      },
    }
  },
  watch: {
    ids(val) {
      if (val && this.$refs['reportForm']) {
        this.$refs['reportForm'].resetFields()
      }
    },
  },
  methods: {
    reportSubmit() {
      this.$refs['reportForm'].validate(valid => {
        if (valid) {
          Doc.reportSubmit({ ...this.report, load_day_ids: this.ids })
            .then(res => {
              if (res.status === 200) {
                this.fetchBids()
                this.$message.success('Отчет(ы) успешно сдан(ы)')
                this.beforeClose()
              }
            })
            .catch(() => this.$message.error('Ошибка!'))
        }
      })
    },
    beforeClose() {
      this.$emit('close', 'report_submitted')
    },
  },
}
</script>
